export default {
  path: '/home',
  name: 'home',
  meta: {
    auth: true,
    title: '首页',
  },
  component: () => import('_views/home/home-index/index'),
}
